<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>招招盈分享</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select
            v-model="listQuery.city"
            clearable
            style="width:150px"
            placeholder="请选择城市"
            filterable
          >
            <el-option
              v-for="(item, index) in cityList"
              :key="index"
              :label="item.cityAddress"
              :value="item.cityAddress"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务者编号">
          <el-input
            v-model="listQuery.workerNo"
            placeholder
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="服务者姓名">
          <el-input
            v-model="listQuery.workerName"
            placeholder
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            plan
            @click="querySearch"
            >查询</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button  type="primary" plain
                        @click="handleCreate">配置海报</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="workerId"
          label="服务者id"
          width="100"
        ></el-table-column>
        <el-table-column prop="city" label="城市"></el-table-column>
        <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
        <el-table-column prop="workerName" label="服务者姓名"></el-table-column>

        <el-table-column prop="state" width="100" label="服务者状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state == 2 ? 'success' : 'warning'">{{
              workerState[scope.row.state]
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="shareStatus" label="分享状态">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.shareStatus == 1 ? 'success' : 'warning'"
              >{{
                scope.row.shareStatus == 1 ? "分享成功" : "分享失败"
              }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="shareTime"
          :formatter="dateFormatA"
          label="分享时间"
        ></el-table-column>
        <!-- <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />

 </el-card>
       <!--新增线索 -->
       <configurePoster ref="configurePoster" />
   
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import configurePoster from "@/components/workercrm/configurePoster.vue";
let vm;
export default {
  components: { Pagination,configurePoster},
  data() {
    return {
      workerState: {
        1: "待上线",
        2: "已上线",
        3: "已解约",
        // 4: "复职",
        5: "上线失败"
      },
      cityList: [],
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        workerNo: "",
        workerName: ""
      },
    };
  },

  created() {
    this.getAllCity();
    this.querySearch();
  },
  activated() {},
  methods: {
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNo = this.currentPage;
      service.$axioGetShareRecord(this.listQuery).then(res => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    },
    handleCreate() {
            //配置海报
            this.$refs.configurePoster.showAddWorkerClue(1);
        },
  },
  beforeCreate() {
    vm = this;
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
.el-dialog__header {
    padding: 20px 20px 10px;
    background-color: #20b6eb !important;
}
</style>
